// Advisor flow analytics events

export const advisorEvents = {
  // ── Dashboard ──────────────────────────────────────────────────────────
  dashboardViewed: (clientCount: number) => ({
    event: 'advisor_dashboard_viewed',
    properties: { client_count: clientCount },
  }),

  // ── Client Management ─────────────────────────────────────────────────
  inviteSent: (role: string, method: string) => ({
    event: 'advisor_invite_sent',
    properties: { role, invite_method: method },
  }),

  inviteAccepted: (role: string) => ({
    event: 'advisor_invite_accepted',
    properties: { role },
  }),

  inviteResent: (role: string) => ({
    event: 'advisor_invite_resent',
    properties: { role },
  }),

  clientSelected: () => ({
    event: 'advisor_client_selected',
    properties: {},
  }),

  accessRevoked: (role: string) => ({
    event: 'advisor_access_revoked',
    properties: { role },
  }),

  // ── Case Review ────────────────────────────────────────────────────────
  caseViewed: (section: string) => ({
    event: 'advisor_case_viewed',
    properties: { section },
  }),

  financialsReviewed: (category: string) => ({
    event: 'advisor_financials_reviewed',
    properties: { category },
  }),

  noteCreated: (isPrivate: boolean, hasReference: boolean) => ({
    event: 'advisor_note_created',
    properties: { is_private: isPrivate, has_reference: hasReference },
  }),

  noteDeleted: () => ({
    event: 'advisor_note_deleted',
    properties: {},
  }),

  // ── Messaging ──────────────────────────────────────────────────────────
  threadCreated: (referenceType?: string) => ({
    event: 'advisor_thread_created',
    properties: { reference_type: referenceType ?? null },
  }),

  messageSent: (visibility: string, messageLength: number) => ({
    event: 'advisor_message_sent',
    properties: { visibility, message_length: messageLength },
  }),

  // ── Team Management ────────────────────────────────────────────────────
  teamPageViewed: (teamCount: number) => ({
    event: 'advisor_team_page_viewed',
    properties: { team_count: teamCount },
  }),

  teamLeft: () => ({
    event: 'advisor_team_left',
    properties: {},
  }),

  // ── Billing ────────────────────────────────────────────────────────────
  billingViewed: () => ({
    event: 'advisor_billing_viewed',
    properties: {},
  }),

  seatsPurchaseStarted: (packageId: string, seatCount: number) => ({
    event: 'advisor_seats_purchase_started',
    properties: { package_id: packageId, seat_count: seatCount },
  }),

  // ── Page Views ─────────────────────────────────────────────────────────
  addClientViewed: () => ({
    event: 'advisor_add_client_viewed',
    properties: {},
  }),

  settingsViewed: () => ({
    event: 'advisor_settings_viewed',
    properties: {},
  }),
};

export type AdvisorEvent = ReturnType<typeof advisorEvents[keyof typeof advisorEvents]>;
